// import { useState } from "react";
// import h5 from "../../../pdf/4830.pdf";
// import Ilmcv from "../ILMCV_Trucks/Ilmcv_Trucks";
// import Tippers from "../Tippers/Tippers";
// import pdf from "../../../pdf";
// import images from "../../images";
// import Buses from "../Buses/Buses";
// import { FiDownload, FiInfo } from "react-icons/fi";
// import v1 from '../../../videos2/SignaVideo.mp4'

// const MHcv = () => {
  // const [formData, setFormData] = useState({
  //   name: "",
  //   email: "",
  //   phone: "",
  //   address: "",
  //   vehicleType: "",
  //   category: ""
  // });

  // const [errors, setErrors] = useState({});
  // const [result, setResult] = useState("");
  // const [isSubmitting, setIsSubmitting] = useState(false);

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   setFormData((prevData) => ({
  //     ...prevData,
  //     [name]: value
  //   }));
  // };

  // const validateForm = () => {
  //   const newErrors = {};
  //   if (!formData.name.trim()) newErrors.name = "Name is required";
  //   if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
  //     newErrors.email = "Valid email required";
  //   if (!formData.phone.match(/^\d{10}$/))
  //     newErrors.phone = "10 digit number required";
  //   if (!formData.address.trim()) newErrors.address = "Address is required";
  //   if (!formData.vehicleType) newErrors.vehicleType = "Model is required";
  //   if (!formData.category) newErrors.category = "Category is required";
  //   return newErrors;
  // };

  // const onSubmit = async (event) => {
  //   event.preventDefault();
  //   const validationErrors = validateForm();
    
  //   if (Object.keys(validationErrors).length > 0) {
  //     setErrors(validationErrors);
  //     return;
  //   }

  //   setIsSubmitting(true);
  //   setResult("Sending enquiry...");
  //   setErrors({});

  //   const formDataObj = new FormData(event.target);
  //   formDataObj.append("access_key", "0ee2e0ad-168f-4ad4-9f5f-c5ba6a59b572");

  //   try {
  //     const response = await fetch("https://api.web3forms.com/submit", {
  //       method: "POST",
  //       body: formDataObj
  //     });

  //     const data = await response.json();

  //     if (data.success) {
  //       setResult("Enquiry submitted successfully!");
  //       event.target.reset();
  //       setFormData({
  //         name: "",
  //         email: "",
  //         phone: "",
  //         address: "",
  //         vehicleType: "",
  //         category: ""
  //       });
  //     } else {
  //       setResult(data.message || "Failed to submit enquiry");
  //     }
  //   } catch (error) {
  //     setResult("Network error. Please try again.");
  //   } finally {
  //     setIsSubmitting(false);
  //   }
  // };

//   const vehicleModels = [
//     {
//       id: 1,
//       name: "TATA SIGNA 5530.S",
//       image: images.signa5530,
//       specs: [
//         { label: "Tonnage (GVW)", value: "55000 Kg" },
//         { label: "Power", value: "3224kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins 6.7L 300HP OBD-II" }
//       ],
//       brochure: pdf.signa5530,
//       link: "/signa5530"
//     },
//     {
//       id: 2,
//       name: "TATA SIGNA 4830.T",
//       image: images.signa4830,
//       specs: [
//         { label: "Tonnage (GVW)", value: "47500 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins Isbe 6.7L OBD-II" }
//       ],
//       brochure: pdf.signa4830,
//       link: "/signa4830"
//     },
//     {
//       id: 3,
//       name: "TATA LPT 4830",
//       image: images.lpt4830,
//       specs: [
//         { label: "Tonnage (GVW)", value: "47500 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins Isbe 6.7L OBD-II" }
//       ],
//       brochure: pdf.signa4830,
//       link: "/lpt4830"
//     }
//   ];

//   const vehicleModels2 = [
//   {
//   id: 1,
//       name: "TATA PRIMA 2830H",
//       image: images.prima2830h,
//       specs: [
//         { label: "Tonnage (GVW)", value: "28000 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins 6.7L OBD-II" }
//       ],
//       brochure: pdf.prima2830h,
//       link: "/prima2830h"
//     },
//      {
//   id: 2,
//       name: "TATA PRIMA 2830S",
//       image: images.prima2830h,
//       specs: [
//         { label: "Tonnage (GVW)", value: "28000 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/mi" },
//         { label: "Engine", value: "Cummins 6.7L OBD-II" }
//       ],
//       brochure: pdf.prima2830s,
//       link: "/prima2830s"
//     },
//      {
//   id: 3,
//       name: "TATA PRIMA 3530H",
//       image: images.prima3530h,
//       specs: [
//         { label: "Tonnage (GVW)", value: "35000 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins 6.7L OBD-II" }
//       ],
//       brochure: pdf.prima3530h,
//       link: "/prima3530h"
//     },
//      {
//   id: 4,
//       name: "TATA PRIMA 3530S",
//       image: images.prima3530s,
//       specs: [
//         { label: "Tonnage (GVW)", value: "35000 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins 6.7L OBD-II" }
//       ],
//       brochure: pdf.prima3530s,
//       link: "/prima3530s"
//     },
//      {
//   id: 5,
//       name: "TATA PRIMA 5530.S",
//       image: images.prima5530s,
//       specs: [
//         { label: "Tonnage (GVW)", value: "55000 Kg" },
//         { label: "Power", value: "224 kW @ 2300 r/min" },
//         { label: "Engine", value: "Cummins 6.7L 300HP OBD-II" }
//       ],
//       brochure: pdf.signa5530,
//       link: "/prima5530s"
//     },
//   ];

//   return (
//     <div className="min-h-screen bg-gray-50">
//       {/* Hero Section */}
//        <div className="relative">
//         <video
//           className="w-full h-[400px] object-cover pt-4"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src={v1} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//         <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
//           <div className="text-center px-4 mt-60">
//             {/* <h1 className="text-3xl md:text-4xl font-bold text-white">
//               TATA MOTORS COMMERCIAL VEHICLES
//             </h1> */}
//             {/* <p className="text-xl text-white">
//               Gangavathi-Sindhanur Road, Marali, Koppal, Karnataka - 583268
//             </p> */}
//           </div>
//         </div>
//       </div>

//       {/* Enquiry Form */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//         <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
//           <div className="md:flex">
//             <div className="md:w-1/2 bg-gradient-to-r from-blue-600 to-blue-800 text-white p-8 md:p-12">
//               <h2 className="text-3xl font-bold mb-4">Get in touch</h2>
//               <p className="mb-6 text-blue-100">
//                 Fill out the form to get expert consultation on our HCV range. Our team will contact
//                 you within 24 hours.
//               </p>
//               <div className="space-y-4">
//                 <div className="flex items-center">
//                   <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                   </svg>
//                   <span>+91 6364861939</span>
//                 </div>
//                 <div className="flex items-center">
//                   <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                   </svg>
//                   <span>Cre@japl.co.in</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="md:w-1/2 p-8 md:p-12">
//               <h2 className="text-3xl font-bold text-gray-800 mb-6">REQUEST FOR QUOTATION</h2>
//               <form onSubmit={onSubmit} className="space-y-6">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div>
//                     <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
//                       Name *
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       id="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.name ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="Your full name"
//                     />
//                     {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
//                       Email *
//                     </label>
//                     <input
//                       type="email"
//                       name="email"
//                       id="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.email ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="your.email@example.com"
//                     />
//                     {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
//                       Phone *
//                     </label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       id="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.phone ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="10 digit mobile number"
//                     />
//                     {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
//                       Address *
//                     </label>
//                     <input
//                       type="text"
//                       name="address"
//                       id="address"
//                       value={formData.address}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.address ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="Your complete address"
//                     />
//                     {errors.address && <p className="mt-1 text-sm text-red-600">{errors.address}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="vehicleType" className="block text-sm font-medium text-gray-700 mb-1">
//                       Select Model *
//                     </label>
//                     <select
//                       name="vehicleType"
//                       id="vehicleType"
//                       value={formData.vehicleType}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.vehicleType ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                     >
//                       <option value="">Select Model</option>
//                       <option value="HCV">HCV</option>
//                       <option value="ICV Trucks">ICV Trucks</option>
//                       <option value="Bus">Buses</option>
//                     </select>
//                     {errors.vehicleType && <p className="mt-1 text-sm text-red-600">{errors.vehicleType}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
//                       Select Category *
//                     </label>
//                     <select
//                       name="category"
//                       id="category"
//                       value={formData.category}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.category ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                     >
//                       <option value="">Select Category</option>
//                       <option value="Haulage">Haulage</option>
//                       <option value="Construck">Construck</option>
//                       <option value="ICV">ICV</option>
//                       <option value="LCV">LCV</option>
//                       <option value="MCV">MCV</option>
//                       <option value="Bus">Bus</option>
//                     </select>
//                     {errors.category && <p className="mt-1 text-sm text-red-600">{errors.category}</p>}
//                   </div>
//                 </div>
                
//                 <div>
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="w-full bg-blue-700 hover:bg-blue-800 text-white font-medium py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center"
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                         </svg>
//                         Processing...
//                       </>
//                     ) : "Submit Enquiry"}
//                   </button>
//                   {result && (
//                     <p className={`mt-3 text-center text-sm ${result.includes("successfully") ? "text-green-600" : "text-yellow-600"}`}>
//                       {result}
//                     </p>
//                   )}
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* HCV Models Section */}
//       <div className="px-4 sm:px-6 lg:px-8 py-12">
//       <div className="max-w-6xl mx-auto">
//       {/* Header Section */}
//         <div className="text-center mb-16">
//           <h2 className="text-3xl font-bold text-gray-900 mb-4">Our HCV Range</h2>
//           <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
//           <p className="mt-6 text-lg text-gray-600 max-w-3xl mx-auto">
//             Explore our range of heavy commercial vehicles designed for performance, durability and efficiency
//           </p>
//             <h2 className="text-3xl font-bold text-gray-900 mb-4 pt-8">Haulage</h2>
//           <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
//         </div>
        
//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {vehicleModels.map((vehicle) => (
//             <div key={vehicle.id} className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105">
//               <div className="h-48 bg-white flex items-center justify-center p-4">
//                 <img 
//                   src={vehicle.image} 
//                   alt={vehicle.name} 
//                   className="h-auto p-4"
//                 />
//               </div>
//               <div className="p-6">
//               <div className="border-b bg-gray-50 mx-8 "></div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>
//                 <ul className="space-y-2 mb-6">
//                   {vehicle.specs.map((spec, index) => (
//                     <li key={index} className="flex justify-between">
//                       <span className="text-gray-600">{spec.label}</span>
//                       <span className="font-medium">{spec.value}</span>
//                     </li>
//                   ))}
//                 </ul>
//                 <div className="flex space-x-3">
//                   <a 
//                     href={vehicle.link}
//                     className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                   >
//                     <FiInfo className="mr-2" /> Details
//                   </a>
//                   <a 
//                     href={vehicle.brochure}
//                     className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <FiDownload className="mr-2" /> Brochure
//                   </a>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>

//         {/* prima section */}
//         {/* Header Section */}
//         <div className="text-center mb-16 mt-12">
//           {/* <h2 className="text-3xl font-bold text-gray-900 mb-4">Our HCV Range</h2> */}
//           {/* <div className="w-20 h-1 bg-blue-600 mx-auto"></div> */}
//           {/* <p className="mt-6 text-lg text-gray-600 max-w-3xl mx-auto">
//             Explore our range of heavy commercial vehicles designed for performance, durability and efficiency
//           </p> */}
//             <h2 className="text-3xl font-bold text-gray-900 mb-4 pt-8">PRIMA</h2>
//           <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
//         </div>

//         <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//           {vehicleModels2.map((vehicle) => (
//             <div key={vehicle.id} className="bg-white rounded-xl shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105">
//               <div className="h-48 bg-white flex items-center justify-center p-4">
//                 <img 
//                   src={vehicle.image} 
//                   alt={vehicle.name} 
//                   className="h-auto p-4"
//                 />
//               </div>
//               <div className="p-6">
//               <div className="border-b bg-gray-50 mx-8 "></div>
//                 <h3 className="text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>
//                 <ul className="space-y-2 mb-6">
//                   {vehicle.specs.map((spec, index) => (
//                     <li key={index} className="flex justify-between">
//                       <span className="text-gray-600">{spec.label}</span>
//                       <span className="font-medium">{spec.value}</span>
//                     </li>
//                   ))}
//                 </ul>
//                 <div className="flex space-x-3">
//                   <a 
//                     href={vehicle.link}
//                     className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                   >
//                     <FiInfo className="mr-2" /> Details
//                   </a>
//                   {/* <a 
//                     href={vehicle.brochure}
//                     className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                     target="_blank"
//                     rel="noopener noreferrer"
//                   >
//                     <FiDownload className="mr-2" /> Brochure
//                   </a> */}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       </div>

//       {/* Additional Sections */}
//       <div className="bg-gray-50 py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <Tippers />
//         </div>
//       </div>

//       <div className="py-16">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <Ilmcv />
//         </div>
//       </div>

//       <div className="">
//         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
//           <Buses />
//         </div>
//       </div>
//       </div>
//     </div>
//   );
// };

// export default MHcv;




// import { useState, useEffect } from "react";
// import { FiDownload, FiInfo } from "react-icons/fi";
// import { Link, Routes, Route, useNavigate } from "react-router-dom";
// import VehicleDetails from "./VehicleDetail"; // We'll create this next
// import v1 from '../../../videos2/SignaVideo.mp4';

// const groupByCategory = (vehicles) => {
//   const categories = {};
//   vehicles.forEach(vehicle => {
//     const cat = vehicle.category || "All Vehicles";
//     if (!categories[cat]) categories[cat] = [];
//     categories[cat].push(vehicle);
//   });
//   return categories;
// };

// const VEHICLE_CACHE_KEY = "vehicleListCacheV1";
// const VEHICLE_CACHE_TIME = 1000 * 60 * 15; // 15 minutes

// const MHcv = () => {
//    const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     address: "",
//     vehicleType: "",
//     category: ""
//   });

//   const [errors, setErrors] = useState({});
//   const [result, setResult] = useState("");
//   const [isSubmitting, setIsSubmitting] = useState(false);

//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData((prevData) => ({
//       ...prevData,
//       [name]: value
//     }));
//   };

//   const validateForm = () => {
//     const newErrors = {};
//     if (!formData.name.trim()) newErrors.name = "Name is required";
//     if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
//       newErrors.email = "Valid email required";
//     if (!formData.phone.match(/^\d{10}$/))
//       newErrors.phone = "10 digit number required";
//     if (!formData.address.trim()) newErrors.address = "Address is required";
//     if (!formData.vehicleType) newErrors.vehicleType = "Model is required";
//     if (!formData.category) newErrors.category = "Category is required";
//     return newErrors;
//   };

//   const onSubmit = async (event) => {
//     event.preventDefault();
//     const validationErrors = validateForm();
    
//     if (Object.keys(validationErrors).length > 0) {
//       setErrors(validationErrors);
//       return;
//     }

//     setIsSubmitting(true);
//     setResult("Sending enquiry...");
//     setErrors({});

//     const formDataObj = new FormData(event.target);
//     formDataObj.append("access_key", "0ee2e0ad-168f-4ad4-9f5f-c5ba6a59b572");

//     try {
//       const response = await fetch("https://api.web3forms.com/submit", {
//         method: "POST",
//         body: formDataObj
//       });

//       const data = await response.json();

//       if (data.success) {
//         setResult("Enquiry submitted successfully!");
//         event.target.reset();
//         setFormData({
//           name: "",
//           email: "",
//           phone: "",
//           address: "",
//           vehicleType: "",
//           category: ""
//         });
//       } else {
//         setResult(data.message || "Failed to submit enquiry");
//       }
//     } catch (error) {
//       setResult("Network error. Please try again.");
//     } finally {
//       setIsSubmitting(false);
//     }
//   };
//   const [vehicles, setVehicles] = useState([]);
//   const [groupedVehicles, setGroupedVehicles] = useState({});
//   const [loading, setLoading] = useState(true);
//   const navigate = useNavigate();

//   useEffect(() => {
//     const fetchVehicles = async () => {
//       setLoading(true);
//       const cached = localStorage.getItem(VEHICLE_CACHE_KEY);
//       if (cached) {
//         const { data, timestamp } = JSON.parse(cached);
//         if (Date.now() - timestamp < VEHICLE_CACHE_TIME) {
//           setVehicles(data);
//           setGroupedVehicles(groupByCategory(data));
//           setLoading(false);
//           return;
//         }
//       }
//       try {
//         // const res = await fetch("https://japl.co.in/api/vehicles"); // update API as needed
//         const res = await fetch("http://localhost:5000/api/vehicles"); 
//         if (!res.ok) throw new Error("Failed to load");
//         const d = await res.json();
//         setVehicles(d);
//         setGroupedVehicles(groupByCategory(d));
//         localStorage.setItem(
//           VEHICLE_CACHE_KEY,
//           JSON.stringify({ data: d, timestamp: Date.now() })
//         );
//       } catch (err) {
//         setVehicles([]);
//         setGroupedVehicles({});
//       }
//       setLoading(false);
//     };
//     fetchVehicles();
//   }, []);

//   if (loading) {
//     return (
//       <div className="min-h-screen flex flex-col items-center justify-center">
//         <svg className="animate-spin h-8 w-8 text-blue-600 mb-3" viewBox="0 0 24 24">
//           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"/>
//           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"/>
//         </svg>
//         <div className="text-lg text-blue-800">Loading vehicles...</div>
//       </div>
//     );
//   }

//   return (
//     <Routes>
//       <Route index element={
//         <div className="min-h-screen bg-gray-50 pb-16">
//             {/* Hero Section */}
//        <div className="relative">
//         <video
//           className="w-full h-[400px] object-cover pt-4"
//           autoPlay
//           loop
//           muted
//           playsInline
//         >
//           <source src={v1} type="video/mp4" />
//           Your browser does not support the video tag.
//         </video>
//         <div className="absolute inset-0 bg-black/30 flex items-center justify-center">
//           <div className="text-center px-4 mt-60">
//             {/* <h1 className="text-3xl md:text-4xl font-bold text-white">
//               TATA MOTORS COMMERCIAL VEHICLES
//             </h1> */}
//             {/* <p className="text-xl text-white">
//               Gangavathi-Sindhanur Road, Marali, Koppal, Karnataka - 583268
//             </p> */}
//           </div>
//         </div>
//       </div>

//       {/* Enquiry Form */}
//       <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//         <div className="bg-white rounded-xl shadow-2xl overflow-hidden">
//           <div className="md:flex">
//             <div className="md:w-1/2 bg-gradient-to-r from-blue-600 to-blue-800 text-white p-8 md:p-12">
//               <h2 className="text-3xl font-bold mb-4">Get in touch</h2>
//               <p className="mb-6 text-blue-100">
//                 Fill out the form to get expert consultation on our HCV range. Our team will contact
//                 you within 24 hours.
//               </p>
//               <div className="space-y-4">
//                 <div className="flex items-center">
//                   <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
//                   </svg>
//                   <span>+91 6364861939</span>
//                 </div>
//                 <div className="flex items-center">
//                   <svg className="w-6 h-6 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
//                   </svg>
//                   <span>Cre@japl.co.in</span>
//                 </div>
//               </div>
//             </div>
            
//             <div className="md:w-1/2 p-8 md:p-12">
//               <h2 className="text-3xl font-bold text-gray-800 mb-6">REQUEST FOR QUOTATION</h2>
//               <form onSubmit={onSubmit} className="space-y-6">
//                 <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
//                   <div>
//                     <label htmlFor="name" className="block text-sm font-medium text-gray-700 mb-1">
//                       Name *
//                     </label>
//                     <input
//                       type="text"
//                       name="name"
//                       id="name"
//                       value={formData.name}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.name ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="Your full name"
//                     />
//                     {errors.name && <p className="mt-1 text-sm text-red-600">{errors.name}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-1">
//                       Email *
//                     </label>
//                     <input
//                       type="email"
//                       name="email"
//                       id="email"
//                       value={formData.email}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.email ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="your.email@example.com"
//                     />
//                     {errors.email && <p className="mt-1 text-sm text-red-600">{errors.email}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="phone" className="block text-sm font-medium text-gray-700 mb-1">
//                       Phone *
//                     </label>
//                     <input
//                       type="tel"
//                       name="phone"
//                       id="phone"
//                       value={formData.phone}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.phone ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="10 digit mobile number"
//                     />
//                     {errors.phone && <p className="mt-1 text-sm text-red-600">{errors.phone}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="address" className="block text-sm font-medium text-gray-700 mb-1">
//                       Address *
//                     </label>
//                     <input
//                       type="text"
//                       name="address"
//                       id="address"
//                       value={formData.address}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.address ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                       placeholder="Your complete address"
//                     />
//                     {errors.address && <p className="mt-1 text-sm text-red-600">{errors.address}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="vehicleType" className="block text-sm font-medium text-gray-700 mb-1">
//                       Select Model *
//                     </label>
//                     <select
//                       name="vehicleType"
//                       id="vehicleType"
//                       value={formData.vehicleType}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.vehicleType ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                     >
//                       <option value="">Select Model</option>
//                       <option value="HCV">HCV</option>
//                       <option value="ICV Trucks">ICV Trucks</option>
//                       <option value="Bus">Buses</option>
//                     </select>
//                     {errors.vehicleType && <p className="mt-1 text-sm text-red-600">{errors.vehicleType}</p>}
//                   </div>
                  
//                   <div>
//                     <label htmlFor="category" className="block text-sm font-medium text-gray-700 mb-1">
//                       Select Category *
//                     </label>
//                     <select
//                       name="category"
//                       id="category"
//                       value={formData.category}
//                       onChange={handleChange}
//                       className={`w-full px-4 py-3 rounded-lg border ${errors.category ? 'border-red-500' : 'border-gray-300'} focus:ring-2 focus:ring-blue-500 focus:border-transparent`}
//                     >
//                       <option value="">Select Category</option>
//                       <option value="Haulage">Haulage</option>
//                       <option value="Construck">Construck</option>
//                       <option value="ICV">ICV</option>
//                       <option value="LCV">LCV</option>
//                       <option value="MCV">MCV</option>
//                       <option value="Bus">Bus</option>
//                     </select>
//                     {errors.category && <p className="mt-1 text-sm text-red-600">{errors.category}</p>}
//                   </div>
//                 </div>
                
//                 <div>
//                   <button
//                     type="submit"
//                     disabled={isSubmitting}
//                     className="w-full bg-blue-700 hover:bg-blue-800 text-white font-medium py-3 px-6 rounded-lg transition duration-300 flex items-center justify-center"
//                   >
//                     {isSubmitting ? (
//                       <>
//                         <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
//                           <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
//                           <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
//                         </svg>
//                         Processing...
//                       </>
//                     ) : "Submit Enquiry"}
//                   </button>
//                   {result && (
//                     <p className={`mt-3 text-center text-sm ${result.includes("successfully") ? "text-green-600" : "text-yellow-600"}`}>
//                       {result}
//                     </p>
//                   )}
//                 </div>
//               </form>
//             </div>
//           </div>
//         </div>
//       </div>

//           <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//             {Object.keys(groupedVehicles).map(category => (
//               <div key={category} className="mb-16">
//                 <div className="text-center mb-10">
//                   <h2 className="text-3xl font-bold text-gray-900 mb-4">{category}</h2>
//                   <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
//                 </div>
//                 <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                   {groupedVehicles[category].map(vehicle => (
//                     <div key={vehicle._id} className="bg-white rounded-xl border shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105">
//                       <div className="h-48 bg-white flex items-center justify-center p-4">
//                         {vehicle.images && vehicle.images.length > 0 ? (
//                           <img src={vehicle.images[0]} alt={vehicle.name} className="h-auto w-full object-contain p-4" />
//                         ) : (
//                           <div className="text-gray-400">No Image</div>
//                         )}
//                       </div>
//                       <div className="p-6">
//                         <div className="border-b bg-gray-50 mx-8"></div>
//                         <h3 className="text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>
//                         {vehicle.quickSpecs ? (
//                           <ul className="space-y-2 mb-6">
//                             {Object.entries(vehicle.quickSpecs).map(([label, value]) =>
//                               value && (
//                                 <li key={label} className="flex justify-between">
//                                   <span className="text-gray-600">{label}</span>
//                                   <span className="font-medium">{value}</span>
//                                 </li>
//                               )
//                             )}
//                           </ul>
//                         ) : (
//                           <p className="text-gray-500 mb-6">No specs available</p>
//                         )}
//                         <div className="flex space-x-3">
//                           <button
//                             onClick={() => navigate(`vehicles/${vehicle._id}`)}
//                             className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                           >
//                             <FiInfo className="mr-2" /> Details
//                           </button>
//                           {vehicle.brochure && (
//                             <a
//                               href={vehicle.brochure}
//                               className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                               target="_blank"
//                               rel="noopener noreferrer"
//                             >
//                               <FiDownload className="mr-2" /> Brochure
//                             </a>
//                           )}
//                         </div>
//                       </div>
//                     </div>
//                   ))}
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       } />
//       <Route path="vehicles/:id" element={<VehicleDetails />} />
//     </Routes>
//   );
// };

// export default MHcv;


// import { useState, useEffect } from "react";
// import { FiDownload, FiInfo, FiPhone, FiMail } from "react-icons/fi";
// import { Link, Routes, Route, useNavigate } from "react-router-dom";
// import VehicleDetails from "./VehicleDetail";
// import logo from "../../../Images/favicon.jpg"; // use your logo path
// import v1 from '../../../videos2/SignaVideo.mp4';
// import API from '../../../Admin/api/api';

// const VEHICLE_CACHE_KEY = "vehicleListCacheV1";
// const VEHICLE_CACHE_TIME = 1000 * 60 * 15; // 15 minutes

// // const API_BASE_URL = 'https://japl-backend.onrender.com/api'
// const API_BASE_URL = 'https://japl-backend-8xvt.onrender.com/api'

// function groupByCategory(vehicles) {
//   const categories = {};
//   vehicles.forEach(vehicle => {
//     const cat = vehicle.category || "All Vehicles";
//     if (!categories[cat]) categories[cat] = [];
//     categories[cat].push(vehicle);
//   });
//   return categories;
// }

// const modelOptions = [
//   { label: "Select Model", value: "" },
//   { label: "HCV", value: "HCV" },
//   { label: "ICV Trucks", value: "ICV Trucks" },
//   { label: "Bus", value: "Bus" },
// ];
// const categoryOptions = [
//   { label: "Select Category", value: "" },
//   { label: "HCV", value: "HCV" },
//   { label: "ILMCV", value: "ILMCV" },
//   { label: "PASSANGER", value: "PASSANGER" },
// ];

// function QuotationForm({ vehicleNames = [] }) {
//   const [formData, setFormData] = useState({
//     name: "",
//     email: "",
//     phone: "",
//     address: "",
//     vehicleType: "",
//     category: "",
//   });
//   const [status, setStatus] = useState(""); // "", "sending", "success", "error", "invalid"
//   const [errors, setErrors] = useState({});

//   // Basic validation
//   const validate = () => {
//     const errs = {};
//     if (!formData.name) errs.name = "Name is required";
//     if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) errs.email = "Valid email required";
//     if (!formData.phone.match(/^\d{10}$/)) errs.phone = "10 digit mobile required";
//     if (!formData.address) errs.address = "Address required";
//     if (!formData.vehicleType) errs.vehicleType = "Model required";
//     if (!formData.category) errs.category = "Category required";
//     return errs;
//   };

//   const handleChange = e => {
//     const { name, value } = e.target;
//     setFormData(f => ({ ...f, [name]: value }));
//   };

//   async function handleSubmit(e) {
//     e.preventDefault();
//     const errs = validate();
//     setErrors(errs);
//     if (Object.keys(errs).length > 0) return setStatus("invalid");
//     setStatus("sending");

//     // -------- Formspree endpoint below, replace with your actual endpoint: --------
//     const FORMSPREE_ENDPOINT = "https://formspree.io/f/xzzrnlbp";
//     try {
//       const resp = await fetch(FORMSPREE_ENDPOINT, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(formData)
//       });
//       if (resp.ok) {
//         setStatus("success");
//         setFormData({
//           name: "", email: "", phone: "", address: "", vehicleType: "", category: "",
//         });
//       } else setStatus("error");
//     } catch {
//       setStatus("error");
//     }
//   }

//   return (
//     <div className="max-w-7xl mx-auto mb-14">
//       <div className="bg-white shadow-2xl rounded-xl flex flex-col md:flex-row overflow-hidden border mt-4">
//         {/* --- Contact Card --- */}
//         <div className="bg-blue-600 text-white md:w-64 w-full flex flex-col items-center justify-center p-6 gap-4">
//           <h2 className="font-bold text-lg mb-2 w-full text-center">CONTACT INFO</h2>
//           <div className="flex flex-col w-full space-y-3 text-white text-[15px]">
//             <span className="flex items-center justify-center"><FiPhone className="mr-2" /> +91 6364861939</span>
//             <span className="flex items-center justify-center"><FiMail className="mr-2" /> Cre@japl.co.in</span>
//           </div>
//           <img src={logo} alt="JAPL Logo" className="rounded-lg w-20 md:w-40 mt-4 " />
//         </div>

//         {/* --- Enquiry Form --- */}
//         <div className="flex-1 p-8 bg-white">
//           <h2 className="text-2xl font-bold text-gray-800 mb-6">REQUEST FOR QUOTATION</h2>
//           <form className="w-full grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-5" onSubmit={handleSubmit}>
//             {/* Row 1 */}
//             <div>
//               <label className="block text-gray-700 mb-1 font-medium">Name *</label>
//               <input
//                 type="text"
//                 name="name"
//                 value={formData.name}
//                 className={`w-full px-4 py-2 border ${errors.name ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500`}
//                 placeholder="Full name"
//                 onChange={handleChange}
//               />
//             </div>
//             <div>
//               <label className="block text-gray-700 mb-1 font-medium">Email *</label>
//               <input
//                 type="email"
//                 name="email"
//                 value={formData.email}
//                 className={`w-full px-4 py-2 border ${errors.email ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500`}
//                 placeholder="Email address"
//                 onChange={handleChange}
//               />
//             </div>
//             <div>
//               <label className="block text-gray-700 mb-1 font-medium">Phone *</label>
//               <input
//                 type="tel"
//                 name="phone"
//                 value={formData.phone}
//                 className={`w-full px-4 py-2 border ${errors.phone ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500`}
//                 placeholder="Mobile number"
//                 onChange={handleChange}
//                 maxLength={10}
//               />
//             </div>
//             {/* Row 2 */}
//             <div className="md:col-span-1">
//               <label className="block text-gray-700 mb-1 font-medium">Address *</label>
//               <input
//                 type="text"
//                 name="address"
//                 value={formData.address}
//                 className={`w-full px-4 py-2 border ${errors.address ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500`}
//                 placeholder="Complete address"
//                 onChange={handleChange}
//               />
//             </div>
//             <div>
//               <label className="block text-gray-700 mb-1 font-medium">Model *</label>
//               <select
//                 name="vehicleType"
//                 value={formData.vehicleType}
//                 className={`w-full px-4 py-2 border ${errors.vehicleType ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500`}
//                 onChange={handleChange}
//               >
//                 {modelOptions.map(opt => (
//                   <option value={opt.value} key={opt.value}>{opt.label}</option>
//                 ))}
//               </select>
//             </div>
//             <div>
//               <label className="block text-gray-700 mb-1 font-medium">Category *</label>
//               <select
//                 name="category"
//                 value={formData.category}
//                 className={`w-full px-4 py-2 border ${errors.category ? "border-red-500" : "border-gray-300"} rounded-lg focus:ring-2 focus:ring-blue-500`}
//                 onChange={handleChange}
//               >
//                 {categoryOptions.map(opt => (
//                   <option value={opt.value} key={opt.value}>{opt.label}</option>
//                 ))}
//               </select>
//             </div>
//             {/* Submit Row (spanning all cols) */}
//             <div className="md:col-span-3">
//               <button
//                 type="submit"
//                 disabled={status === "sending"}
//                 className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-md font-semibold text-base transition mt-2"
//                 style={{ letterSpacing: 0.5 }}
//               >
//                 {status === "sending"
//                   ? "Submitting..."
//                   : "SUBMIT ENQUIRY"}
//               </button>
//               {/* Status/Error messages */}
//               {status === "success" && (
//                 <div className="text-green-700 text-center mt-2">Successfully submitted! <br /> You will receive the quotation to your whatsapp.</div>
//               )}
//               {status === "invalid" && (
//                 <div className="text-red-600 text-center mt-2">Please check highlighted fields.</div>
//               )}
//               {status === "error" && (
//                 <div className="text-red-600 text-center mt-2">Something went wrong. Please try again.</div>
//               )}
//             </div>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// }

// // ----------------- MAIN MHcv PAGE -----------------
// const MHcv = () => {
//   const [vehicles, setVehicles] = useState([]);
//   const [groupedVehicles, setGroupedVehicles] = useState({});
//   const [cacheChecked, setCacheChecked] = useState(false);
//   const navigate = useNavigate();
//   // Show cache immediately, then update in background
//   useEffect(() => {
//     const cached = localStorage.getItem(VEHICLE_CACHE_KEY);
//     if (cached) {
//       const { data } = JSON.parse(cached);
//       setVehicles(data);
//       setGroupedVehicles(groupByCategory(data));
//       setCacheChecked(true);
//     } else {
//       setCacheChecked(true);
//     }
//     (async () => {
//       try {
//         const res = await fetch(`${API_BASE_URL}/vehicles`);
//         // const res = await fetch("/vehicles");
//         if (!res.ok) throw new Error("Failed to load");
//         const d = await res.json();
//         setVehicles(d);
//         setGroupedVehicles(groupByCategory(d));
//         localStorage.setItem(
//           VEHICLE_CACHE_KEY,
//           JSON.stringify({ data: d, timestamp: Date.now() })
//         );
//       } catch { /* fallback to cache silently */ }
//     })();
//   }, []);

//   return (
//     <Routes>
//       <Route
//         index
//         element={
//           <div className="min-h-screen bg-gray-50 pb-16">
//             {/* Hero Video */}
//             <div className="relative">
//               <video
//                 className="w-full h-[400px] object-cover pt-4"
//                 autoPlay
//                 loop
//                 muted
//                 playsInline
//               >
//                 <source src={v1} type="video/mp4" />
//                 Your browser does not support the video tag.
//               </video>
//               <div className="absolute inset-0 bg-black/30 flex items-center justify-center" />
//             </div>
//             {/* Modern Quotation Form */}
//             <QuotationForm vehicleNames={vehicles.map(v => v.name)} />
//             {/* Vehicles Grid */}
//             <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
//               {Object.keys(groupedVehicles).length === 0 && cacheChecked && (
//                 <div className="text-center mt-12 text-gray-400">No vehicles available.</div>
//               )}
//               {Object.keys(groupedVehicles).map(category => (
//                 <div key={category} className="mb-16">
//                   <div className="text-center mb-10">
//                     <h2 className="text-3xl font-bold text-gray-900 mb-4">{category}</h2>
//                     <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
//                   </div>
//                   <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
//                     {groupedVehicles[category].map(vehicle => (
//                       <div
//                         key={vehicle._id}
//                         className="bg-white rounded-xl border shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105"
//                       >
//                         <div className="h-48 bg-white flex items-center justify-center p-4">
//                           {vehicle.images && vehicle.images.length > 0 ? (
//                             <img src={vehicle.images[0]} alt={vehicle.name} className="h-auto w-full object-contain p-4" />
//                           ) : (
//                             <div className="text-gray-400">No Image</div>
//                           )}
//                         </div>
//                         <div className="p-6">
//                           <div className="border-b bg-gray-50 mx-8"></div>
//                           <h3 className="text-xl font-bold text-gray-900 mb-3">{vehicle.name}</h3>
//                           {vehicle.quickSpecs ? (
//                             <ul className="space-y-2 mb-6">
//                               {Object.entries(vehicle.quickSpecs).map(([label, value]) =>
//                                 value && (
//                                   <li key={label} className="flex justify-between">
//                                     <span className="text-gray-600">{label}</span>
//                                     <span className="font-medium">{value}</span>
//                                   </li>
//                                 )
//                               )}
//                             </ul>
//                           ) : (
//                             <p className="text-gray-500 mb-6">No specs available</p>
//                           )}
//                           <div className="flex space-x-3">
//                             <button
//                               onClick={() => navigate(`vehicles/${vehicle._id}`)}
//                               className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                             >
//                               <FiInfo className="mr-2" /> Details
//                             </button>
//                             {vehicle.brochure && (
//                               <a
//                                 href={vehicle.brochure}
//                                 className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
//                                 target="_blank"
//                                 rel="noopener noreferrer"
//                               >
//                                 <FiDownload className="mr-2" /> Brochure
//                               </a>
//                             )}
//                           </div>
//                         </div>
//                       </div>
//                     ))}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         }
//       />
//       <Route path="vehicles/:id" element={<VehicleDetails />} />
//     </Routes>
//   );
// };

// export default MHcv;



// new code 19-12-25

import { useState, useEffect } from "react";
import { FiDownload, FiInfo, FiPhone, FiMail } from "react-icons/fi";
import { Link, Routes, Route, useNavigate } from "react-router-dom";
import VehicleDetails from "./VehicleDetail";
import logo from "../../../Images/favicon.jpg";
import v1 from "../../../videos2/SignaVideo.mp4";
import API from "../../../Admin/api/api"; // (unused but kept in case you need later)

const VEHICLE_CACHE_KEY = "vehicleListCacheV1";
const VEHICLE_CACHE_TIME = 1000 * 60 * 15; // 15 minutes

// BACKEND BASE URL (production)
const API_BASE_URL = (process.env.NODE_ENV === 'production' ? "https://japl-backend-v2jm.onrender.com/api" : 'http://localhost:5000/api');

// ------------- Helper: group vehicles by category -------------
function groupByCategory(vehicles) {
  const categories = {};
  vehicles.forEach((vehicle) => {
    const cat = vehicle.category || "All Vehicles";
    if (!categories[cat]) categories[cat] = [];
    categories[cat].push(vehicle);
  });
  return categories;
}

// ------------- Constants for quotation form -------------
const modelOptions = [
  { label: "Select Model", value: "" },
  { label: "HCV", value: "HCV" },
  { label: "ICV Trucks", value: "ICV Trucks" },
  { label: "Bus", value: "Bus" },
];

const categoryOptions = [
  { label: "Select Category", value: "" },
  { label: "HCV", value: "HCV" },
  { label: "ILMCV", value: "ILMCV" },
  { label: "PASSANGER", value: "PASSANGER" },
];

// ------------- Quotation Form Component -------------
function QuotationForm({ vehicleNames = [] }) {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: "",
    vehicleType: "",
    category: "",
  });
  const [status, setStatus] = useState(""); // "", "sending", "success", "error", "invalid"
  const [errors, setErrors] = useState({});

  // Basic validation
  const validate = () => {
    const errs = {};
    if (!formData.name) errs.name = "Name is required";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      errs.email = "Valid email required";
    if (!formData.phone.match(/^\d{10}$/))
      errs.phone = "10 digit mobile required";
    if (!formData.address) errs.address = "Address required";
    if (!formData.vehicleType) errs.vehicleType = "Model required";
    if (!formData.category) errs.category = "Category required";
    return errs;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((f) => ({ ...f, [name]: value }));
  };

  async function handleSubmit(e) {
    e.preventDefault();
    const errs = validate();
    setErrors(errs);
    if (Object.keys(errs).length > 0) {
      setStatus("invalid");
      return;
    }
    setStatus("sending");

    const FORMSPREE_ENDPOINT = "https://formspree.io/f/xzzrnlbp";
    try {
      const resp = await fetch(FORMSPREE_ENDPOINT, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });
      if (resp.ok) {
        setStatus("success");
        setFormData({
          name: "",
          email: "",
          phone: "",
          address: "",
          vehicleType: "",
          category: "",
        });
      } else {
        setStatus("error");
      }
    } catch {
      setStatus("error");
    }
  }

  return (
    <div className="max-w-7xl mx-auto mb-14">
      <div className="bg-white shadow-2xl rounded-xl flex flex-col md:flex-row overflow-hidden border mt-4">
        {/* --- Contact Card --- */}
        <div className="bg-blue-600 text-white md:w-64 w-full flex flex-col items-center justify-center p-6 gap-4">
          <h2 className="font-bold text-lg mb-2 w-full text-center">
            CONTACT INFO
          </h2>
          <div className="flex flex-col w-full space-y-3 text-white text-[15px]">
            <span className="flex items-center justify-center">
              <FiPhone className="mr-2" /> +91 6364861939
            </span>
            <span className="flex items-center justify-center">
              <FiMail className="mr-2" /> Cre@japl.co.in
            </span>
          </div>
          <img
            src={logo}
            alt="JAPL Logo"
            className="rounded-lg w-20 md:w-40 mt-4 "
          />
        </div>

        {/* --- Enquiry Form --- */}
        <div className="flex-1 p-8 bg-white">
          <h2 className="text-2xl font-bold text-gray-800 mb-6">
            REQUEST FOR QUOTATION
          </h2>
          <form
            className="w-full grid grid-cols-1 md:grid-cols-3 gap-x-4 gap-y-5"
            onSubmit={handleSubmit}
          >
            {/* Row 1 */}
            <div>
              <label className="block text-gray-700 mb-1 font-medium">
                Name *
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                className={`w-full px-4 py-2 border ${
                  errors.name ? "border-red-500" : "border-gray-300"
                } rounded-lg focus:ring-2 focus:ring-blue-500`}
                placeholder="Full name"
                onChange={handleChange}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1 font-medium">
                Email *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                className={`w-full px-4 py-2 border ${
                  errors.email ? "border-red-500" : "border-gray-300"
                } rounded-lg focus:ring-2 focus:ring-blue-500`}
                placeholder="Email address"
                onChange={handleChange}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1 font-medium">
                Phone *
              </label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                className={`w-full px-4 py-2 border ${
                  errors.phone ? "border-red-500" : "border-gray-300"
                } rounded-lg focus:ring-2 focus:ring-blue-500`}
                placeholder="Mobile number"
                onChange={handleChange}
                maxLength={10}
              />
            </div>
            {/* Row 2 */}
            <div className="md:col-span-1">
              <label className="block text-gray-700 mb-1 font-medium">
                Address *
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                className={`w-full px-4 py-2 border ${
                  errors.address ? "border-red-500" : "border-gray-300"
                } rounded-lg focus:ring-2 focus:ring-blue-500`}
                placeholder="Complete address"
                onChange={handleChange}
              />
            </div>
            <div>
              <label className="block text-gray-700 mb-1 font-medium">
                Model *
              </label>
              <select
                name="vehicleType"
                value={formData.vehicleType}
                className={`w-full px-4 py-2 border ${
                  errors.vehicleType ? "border-red-500" : "border-gray-300"
                } rounded-lg focus:ring-2 focus:ring-blue-500`}
                onChange={handleChange}
              >
                {modelOptions.map((opt) => (
                  <option value={opt.value} key={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            <div>
              <label className="block text-gray-700 mb-1 font-medium">
                Category *
              </label>
              <select
                name="category"
                value={formData.category}
                className={`w-full px-4 py-2 border ${
                  errors.category ? "border-red-500" : "border-gray-300"
                } rounded-lg focus:ring-2 focus:ring-blue-500`}
                onChange={handleChange}
              >
                {categoryOptions.map((opt) => (
                  <option value={opt.value} key={opt.value}>
                    {opt.label}
                  </option>
                ))}
              </select>
            </div>
            {/* Submit Row */}
            <div className="md:col-span-3">
              <button
                type="submit"
                disabled={status === "sending"}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white py-3 rounded-md font-semibold text-base transition mt-2"
                style={{ letterSpacing: 0.5 }}
              >
                {status === "sending" ? "Submitting..." : "SUBMIT ENQUIRY"}
              </button>
              {status === "success" && (
                <div className="text-green-700 text-center mt-2">
                  Successfully submitted! <br /> You will receive the quotation
                  to your whatsapp.
                </div>
              )}
              {status === "invalid" && (
                <div className="text-red-600 text-center mt-2">
                  Please check highlighted fields.
                </div>
              )}
              {status === "error" && (
                <div className="text-red-600 text-center mt-2">
                  Something went wrong. Please try again.
                </div>
              )}
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

// ----------------- MAIN MHcv PAGE -----------------
const MHcv = () => {
  const [vehicles, setVehicles] = useState([]);
  const [groupedVehicles, setGroupedVehicles] = useState({});
  const [cacheChecked, setCacheChecked] = useState(false);

  const [loading, setLoading] = useState(true); // new
  const [error, setError] = useState(null); // new

  const navigate = useNavigate();

  useEffect(() => {
    let isMounted = true;

    const loadFromCache = () => {
      try {
        const cached = localStorage.getItem(VEHICLE_CACHE_KEY);
        if (!cached) return null;

        const parsed = JSON.parse(cached);
        if (
          !parsed ||
          !Array.isArray(parsed.data) ||
          typeof parsed.timestamp !== "number"
        ) {
          return null;
        }

        const isExpired = Date.now() - parsed.timestamp > VEHICLE_CACHE_TIME;
        if (isExpired) return null;

        return parsed.data;
      } catch {
        return null;
      }
    };

    // 1. Try cache first
    const cachedData = loadFromCache();
    if (cachedData && isMounted) {
      setVehicles(cachedData);
      setGroupedVehicles(groupByCategory(cachedData));
      setCacheChecked(true);
      setLoading(false); // we already have data
    } else {
      setCacheChecked(true);
    }

    // 2. Always try to refresh from network in background
    // async function fetchVehicles() {
    //   try {
    //     setLoading(true);
    //     setError(null);

    //     const res = await fetch(`${API_BASE_URL}/vehicles`, {
    //       headers: {
    //         "Content-Type": "application/json",
    //       },
    //     });

    //     if (!res.ok) {
    //       throw new Error(`Failed to load vehicles: ${res.status}`);
    //     }

    //     const d = await res.json();

    //     if (!Array.isArray(d)) {
    //       throw new Error("Invalid vehicles response");
    //     }

    //     if (!isMounted) return;

    //     setVehicles(d);
    //     setGroupedVehicles(groupByCategory(d));

    //     try {
    //       localStorage.setItem(
    //         VEHICLE_CACHE_KEY,
    //         JSON.stringify({ data: d, timestamp: Date.now() })
    //       );
    //     } catch {
    //       // ignore cache write error
    //     }

    //     setLoading(false);
    //   } catch (err) {
    //     if (!isMounted) return;

    //     // If we had no cache and network fails, show error
    //     if (!cachedData || cachedData.length === 0) {
    //       setError(
    //         "Unable to load vehicles right now. Please check your internet or try again in a few seconds."
    //       );
    //     }
    //     setLoading(false);
    //   }
    // }

    async function fetchVehicles(retry = false) {
  try {
    setLoading(true);
    setError(null);

    const res = await fetch(`${API_BASE_URL}/vehicles`, {
      headers: {
        "Content-Type": "application/json",
      },
    });

    if (!res.ok) {
      throw new Error(`Failed to load vehicles: ${res.status}`);
    }

    const d = await res.json();

    if (!Array.isArray(d)) {
      throw new Error("Invalid vehicles response");
    }

    if (!isMounted) return;

    setVehicles(d);
    setGroupedVehicles(groupByCategory(d));

    try {
      localStorage.setItem(
        VEHICLE_CACHE_KEY,
        JSON.stringify({ data: d, timestamp: Date.now() })
      );
    } catch {}

    setLoading(false);
  } catch (err) {
    if (!isMounted) return;

    // one retry on failure
    if (!retry) {
      setTimeout(() => fetchVehicles(true), 1000);
      return;
    }

    // only show error if absolutely no data
    if (!cachedData || cachedData.length === 0) {
      setError(
        "Unable to load vehicles right now. Please try again in a few seconds."
      );
    }

    setLoading(false);
  }
}


    fetchVehicles();

    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <Routes>
      <Route
        index
        element={
          <div className="min-h-screen bg-gray-50 pb-16">
            {/* Hero Video */}
            <div className="relative">
              <video
                className="w-full h-[400px] object-cover pt-4"
                autoPlay
                loop
                muted
                playsInline
              >
                <source src={v1} type="video/mp4" />
                Your browser does not support the video tag.
              </video>
              <div className="absolute inset-0 bg-black/30 flex items-center justify-center" />
            </div>

            {/* Quotation Form */}
            <QuotationForm vehicleNames={vehicles.map((v) => v.name)} />

            {/* Vehicles Grid */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
              {/* Loading state (important for Render cold starts) */}
              {loading && (
                <div className="text-center mt-12 text-gray-500">
                  Loading vehicles... First load may take a few seconds.
                </div>
              )}

              {/* Error state */}
              {!loading && error && (
                <div className="text-center mt-12 text-red-500">
                  {error}
                </div>
              )}

              {/* Empty state */}
              {!loading &&
                !error &&
                Object.keys(groupedVehicles).length === 0 &&
                cacheChecked && (
                  <div className="text-center mt-12 text-gray-400">
                    No vehicles available.
                  </div>
                )}

              {/* Vehicles list */}
              {!loading &&
                !error &&
                Object.keys(groupedVehicles).length > 0 &&
                Object.keys(groupedVehicles).map((category) => (
                  <div key={category} className="mb-16">
                    <div className="text-center mb-10">
                      <h2 className="text-3xl font-bold text-gray-900 mb-4">
                        {category}
                      </h2>
                      <div className="w-20 h-1 bg-blue-600 mx-auto"></div>
                    </div>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                      {groupedVehicles[category].map((vehicle) => (
                        <div
                          key={vehicle._id}
                          className="bg-white rounded-xl border shadow-lg overflow-hidden transition-transform duration-300 hover:scale-105"
                        >
                          <div className="h-48 bg-white flex items-center justify-center p-4">
                            {vehicle.images && vehicle.images.length > 0 ? (
                              <img
                                src={vehicle.images[0]}
                                alt={vehicle.name}
                                className="h-auto w-full object-contain p-4"
                              />
                            ) : (
                              <div className="text-gray-400">No Image</div>
                            )}
                          </div>
                          <div className="p-6">
                            <div className="border-b bg-gray-50 mx-8"></div>
                            <h3 className="text-xl font-bold text-gray-900 mb-3">
                              {vehicle.name}
                            </h3>
                            {vehicle.quickSpecs ? (
                              <ul className="space-y-2 mb-6">
                                {Object.entries(vehicle.quickSpecs).map(
                                  ([label, value]) =>
                                    value && (
                                      <li
                                        key={label}
                                        className="flex justify-between"
                                      >
                                        <span className="text-gray-600">
                                          {label}
                                        </span>
                                        <span className="font-medium">
                                          {value}
                                        </span>
                                      </li>
                                    )
                                )}
                              </ul>
                            ) : (
                              <p className="text-gray-500 mb-6">
                                No specs available
                              </p>
                            )}
                            <div className="flex space-x-3">
                              <button
                                onClick={() =>
                                  navigate(`vehicles/${vehicle._id}`)
                                }
                                className="flex-1 bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
                              >
                                <FiInfo className="mr-2" /> Details
                              </button>
                              {vehicle.brochure && (
                                <a
                                  href={vehicle.brochure}
                                  className="flex-1 bg-gray-100 hover:bg-gray-200 text-gray-800 font-medium py-2 px-4 rounded-lg flex items-center justify-center transition"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <FiDownload className="mr-2" /> Brochure
                                </a>
                              )}
                            </div>
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        }
      />
      <Route path="vehicles/:id" element={<VehicleDetails />} />
    </Routes>
  );
};

export default MHcv;
